import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ddff4b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bank-wrapper" }
const _hoisted_2 = { class: "register-help" }
const _hoisted_3 = {
  class: "border-bottom",
  style: {"margin-top":"24px","padding-bottom":"24px"}
}
const _hoisted_4 = { class: "help-file-wrapper" }
const _hoisted_5 = { style: {"margin":"24px auto 17px"} }
const _hoisted_6 = { class: "ris-wrapper" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ris-content" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"white-space":"nowrap"} }, " 开⽴账户时，请提前联系集团财务-林伟 电话：15301090540，指导新晋VP将银⾏接⼊集团的资⾦管理系统。 "),
  /*#__PURE__*/_createElementVNode("p", { class: "orange" }, "注意：请务必开户前联系，可以尽量避免重复性工作。")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "form-wrapper",
  s: ""
}
const _hoisted_10 = { style: {"padding":"24px","padding-bottom":"60px"} }
const _hoisted_11 = { class: "content-wrapper" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bank-name" }, "开户行名称", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("招商银行")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("建设银行")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("民生银行")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("广发银行")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bank-name" }, "开户所需集团资料申请", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { style: {"color":"#333"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "基本存款账户编号"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#666"} }, "(开户许可证可查)")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("客户经理电话/柜"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("台电话")
], -1))
const _hoisted_23 = {
  key: 4,
  class: "flow-box"
}

import {
  onMounted,
  ref,
  reactive,
  computed,
  withDefaults,
  watch,
  watchEffect,
  createVNode,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import type { FormInstance } from "ant-design-vue";
import { message, Modal } from "ant-design-vue";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import HeadTitle from "@/components/HeadTitle.vue";
import HelpFile from "@/components/HelpFile.vue";
import HelpText from "@/components/HelpText.vue";
import Approval from "@/components/Approval.vue";
import ButtonGroup from "@/components/ButtonGroup.vue";
import Image from "@/components/Image.vue";
import Acccount from "./Detail/Account.vue";
import Tax from "./Detail/Tax.vue";
import Register from "./Detail/Register1.vue";
import { USERLIST, BOOKLIST } from "@/const/home";

import { FileType, File, NodeItem } from "@/types/procss";

import {
  getBankAccountApply,
  startBankAccountApply,
  getTaxReporting,
  startTaxReporting,
  getBankAccountRegistration,
  startBankAccountRegistration,
  submitAccountTaxApply,
  accountTaxApplyInfo,
  submitTaxCategoryApply,
  taxCategoryApplyInfo,
} from "@/api/process_bank";

import { GetCurrentMyPageList } from "@/api/index";


export default /*#__PURE__*/_defineComponent({
  props: {
    flowData: { default: () => [] }
  },
  emits: ["update-flow"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { flowData: NodeItem[] }

const currentStep = ref<number>(0);
const activeKey = ref<string>("605");

const actionButtons = ref<(string | number)[]>([]); //默认是申请审批
const visible = ref<boolean>(false);
const store = useStore();
const personInfo = computed(() => store.getters.getSimpleInfo);
const route = useRoute();
const { query } = route;
const id = ref(query.id || "");
const rejectedVisible = ref<boolean>(false);
const applyOnOkVisible = ref<boolean>(false);
const preButton = ref<(string | number)[]>([]); //存储重新发起点击前按钮
const reEdit = ref<boolean>(false); //是否点击重新发起标识

const edit = computed(() => actionButtons.value.includes("100"));

const currentData = ref<NodeItem>();
const firstIn = ref<boolean>(true);

const preData = ref<NodeItem>();
const BranchCompanyFlowId = ref<number>(0);

const WorkFlowId = ref<number>(0);
watch(
  () => props.flowData,
  (val) => {
    if (!val) return;
    const { id, type } = route.query;
    if (id && type) {
      //从列表也进入
      BranchCompanyFlowId.value = id;

      currentData.value = val.find((item: NodeItem) => item.Code == type);
      if (currentData.value.ChildAnchorPointCode) {
        currentData.value = val.find(
          (item: NodeItem) =>
            item.Code == currentData.value.ChildAnchorPointCode
        );
      }
      currentStep.value =
        currentData.value?.Code == "601"
          ? 0
          : currentData.value?.Code == "604"
          ? 1
          : currentData.value?.Code == "603"
          ? 3
          : 2;
      if (currentStep.value == 2) {
        activeKey.value = currentData.value?.Code == "605" ? "605" : "602";
        filterCompanyCode(activeKey.value);
      }
    } else {
      //从流程节点页面进入
      let _parent_data = val.find((item: NodeItem) => item.Code == "6");
      currentData.value = val.find(
        (item: NodeItem) => item.Code == _parent_data?.ChildAnchorPointCode
      );
      if (currentData.value) {
        if (firstIn.value) {
          //第一次进入
          currentStep.value =
            currentData.value?.Code == "601"
              ? 0
              : currentData.value?.Code == "604"
              ? 1
              : currentData.value?.Code == "603"
              ? 3
              : 2;
          if (currentStep.value == 2) {
            activeKey.value = currentData.value?.Code == "605" ? "605" : "602";
            filterCompanyCode(activeKey.value);
          }
        }
      }
    }
    firstIn.value = false;
    handleTabChange(currentStep.value);
  },
  {
    deep: true,
  }
);


const form = ref({
  BranchCompanyFlowId: 0,
  YhBankName: "",
  YhCompanyEntity: "",
  YhDocumentCollection: [],
});
let form2 = ref<{ PageFiles: File[] }>({
  PageFiles: [
    {
      FileName: "",
      FileUrl: "",
      AccessoryType: 0,
      Url: "",
    },
    {
      FileName: "",
      FileUrl: "",
      AccessoryType: 0,
      Url: "",
    },
  ],
});

let form3 = ref({
  AccountName: "",
  BankName: "",
  AccountNumber: "",
  DepositAccountNumber: "",
  OpeningDate: "",
  AccountManagerName: "",
  AccountManagerPhone: "",
});
const refresh = ref<boolean>(false);

let form4 = ref<{ PageFiles: File[] }>({
  PageFiles: [],
});
const formRef1 = ref<FormInstance>(); //选址表单
const formRef2 = ref<FormInstance>(); //选址表单
const formRef3 = ref<FormInstance>(); //选址表单
const formRef4 = ref<FormInstance>(); //选址表单

const taxForm = ref({
  Description: "",
  TaxCategoryList: [],
});
const taxDetailForm = ref({});

const plainOptions = [
  "公章",
  "法人章",
  "合同章",
  "发票章",
  "财务章",
  "营业执照正本",
  "营业执照副本",
  "法人身份证",
  "股东身份证(Lisa)",
  "集团公司章程",
];

const taxOptions = [
  "企业所得税",
  "个人所得税",
  "增值税",
  "城市维护建设税",
  "教育费附加",
  "地方教育费附加",
  "残保金",
  "印花税-营业账簿",
  "印花税-租赁合同",
  "其他",
];

const formState = reactive<Record<string, any>>({
  upload: "",
});

const formItemLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 14 },
};

const flag = ref<boolean>(false);

const fileList: { title: string; type: FileType; link: string }[] = [
  {
    title: "集团财务篇",
    type: FileType.PDF,
    link: "https://static2.risfond.com//hrsop/onlineOpening/2024/202406/20240613/20240613_112609797574942_集团财务篇.pdf",
  },
];

const tableData = [
  {
    depart: "财务管理中心",
    name: "张馨予",
    duty: "财务支持全模",
    email: "Zhangxinyu@risfond.com",
    phone: "15010170908",
  },
  {
    depart: "财务管理中心",
    name: "张⼩光",
    duty: "银行开户、税务报道咨询",
    email: "eden.zhang@risfond.com",
    phone: "13671096650",
  },
  {
    depart: "风控合规中心",
    name: "郑晓雪",
    duty: "房屋租赁合同审批、工商注册及备案审批",
    email: "xiaoxue.zheng@risfond.com",
    phone: "13911699671",
  },
];
const list = [
  "提交银行开户申请",
  "提交开户报税资料申请",
  "提交税务报道申请",
  "提交银行开户备案资料",
];

const handleReSubmit = () => {
  if (currentStep.value == 0) {
    submit1();
  } else if (currentStep.value == 1) {
    submit4();
  } else if (currentStep.value == 2) {
    if (activeKey.value == "605") {
      submit5();
    } else {
      submit2();
    }
  } else if (currentStep.value == 3) {
    submit3();
  }
};

const handleClick = async (buttonType: string | number) => {
  if (buttonType == "100") {
    handleReSubmit();
  } else if (buttonType == "102") {
    preButton.value = actionButtons.value;
    actionButtons.value = ["-1", "-2"];
    reEdit.value = true;
  } else if (buttonType == "101") {
    visible.value = true;
  } else if (buttonType == "104") {
    //驳回
    rejectedVisible.value = true;
  } else if (buttonType == "103") {
    //通过
    applyOnOkVisible.value = true;
  } else if (buttonType == "-1") {
    reEdit.value = false;
    handleTabChange(currentStep.value);
    //节点
  } else if (buttonType == "-2") {
    handleReSubmit();
  } else if (buttonType == "306") {
    //开户报税资料补充
    visibleCompleted.value = true;
  }
};
const getList = async () => {
  const { Success, Data } = await GetCurrentMyPageList();

  if (Success) {
    store.commit("setWaitList", Data.ApproveCount);
    store.commit("setToList", Data.ToCCCount);
  }
};

const submit1 = async () => {
  formRef1.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await startBankAccountApply({
      BranchCompanyFlowId: BranchCompanyFlowId.value,
      PageData: {
        YhBankName: form.value.YhBankName,
        YhCompanyEntity: form.value.YhCompanyEntity,
        YhDocumentCollection: form.value.YhDocumentCollection.join(","),
      },
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const submit4 = async () => {
  formRef5.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await submitAccountTaxApply({
      BranchCompanyFlowId: BranchCompanyFlowId.value,
      PageFiles: form5.value.PageFiles || [],
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const submit5 = async () => {
  if (taxForm.value.TaxCategoryList.length === 0) {
    return message.warning("请选择税种");
  }
  if (
    taxForm.value.TaxCategoryList.includes(9) &&
    taxForm.value.Description == ""
  ) {
    return message.warning("请填写需要申请的税种");
  }
  let TaxCategoryList = [];
  taxForm.value.TaxCategoryList.forEach((item) => {
    TaxCategoryList.push({
      Type: item,
      Description: item == 9 ? taxForm.value.Description : null,
    });
  });
  const { Success, Message } = await submitTaxCategoryApply({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
    PageData: {
      TaxCategoryList,
    },
  });
  if (Success) {
    message.success("已提交审核");
    $emit("update-flow");
    reEdit.value = false;
  } else {
    message.error(Message || "提交失败，请稍后重试");
  }
};

const submit2 = async () => {
  formRef2.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await startTaxReporting({
      BranchCompanyFlowId: BranchCompanyFlowId.value,
      PageFiles: form2.value.PageFiles || [],
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      reEdit.value = false;
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};

const submit3 = async () => {
  formRef3.value?.validateFields().then(async (res) => {
    formRef4.value?.validateFields().then(async (res) => {
      //提交申请
      const { Success, Message } = await startBankAccountRegistration({
        BranchCompanyFlowId: BranchCompanyFlowId.value,
        PageData: form3.value || {},
        PageFiles: form4.value.PageFiles || [],
      });
      if (Success) {
        message.success("已提交审核");
        $emit("update-flow");
        reEdit.value = false;
      } else {
        message.error(Message || "提交失败，请稍后重试");
      }
    });
  });
};
watchEffect(() => {
  const { id } = route.query;
  if (id) {
    if (!actionButtons.value.includes("90")) {
      actionButtons.value.unshift("90");
    }
  }
});

const BankAccountApply = async () => {
  const { Data } = await getBankAccountApply({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });

  if (Data?.PageData) {
    form.value = Data?.PageData;
    form.value.YhDocumentCollection =
      Data?.PageData.YhDocumentCollection.split(",") || "";
  }
  actionButtons.value = Data?.ActionButtons || [];
  WorkFlowId.value = Data?.WorkFlowId;
};

const getAccountTaxApplyInfo = async () => {
  const { Data } = await accountTaxApplyInfo({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  WorkFlowId.value = Data?.WorkFlowId;

  if (Data?.PageFiles?.length > 0) {
    form5.value.PageFiles = Data?.PageFiles;
  }
  form5.value.PostFiles = Data?.PostFiles;

  actionButtons.value = Data?.ActionButtons || [];
};
const getTaxCategoryApplyInfo = async () => {
  const { Data } = await taxCategoryApplyInfo({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });

  if (Data?.PageData) {
    // taxForm.value = Data?.PageData;
    taxForm.value.TaxCategoryList = [];
    Data.PageData.TaxCategoryList.forEach((item) => {
      taxForm.value.TaxCategoryList.push(item.Type);
      if (item.Type == 9) {
        taxForm.value.Description = item.Description;
      }
    });
    taxDetailForm.value.TaxCategoryList = Data?.PageData.TaxCategoryList;
  }
  actionButtons.value = Data?.ActionButtons || [];
  WorkFlowId.value = Data?.WorkFlowId;
};

const taxReporting = async () => {
  const { Data } = await getTaxReporting({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  WorkFlowId.value = Data?.WorkFlowId;

  if (Data?.PageFiles?.length > 0) {
    form2.value.PageFiles = Data?.PageFiles;
  }
  actionButtons.value = Data?.ActionButtons || [];
};

const bankAccountRegistration = async () => {
  const { Data } = await getBankAccountRegistration({
    BranchCompanyFlowId: BranchCompanyFlowId.value,
  });
  WorkFlowId.value = Data?.WorkFlowId;

  if (Data?.PageData) {
    form3.value = Data?.PageData || {};
  }
  if (Data?.PageFiles?.length > 0) {
    form4.value.PageFiles = Data?.PageFiles || {};
  }
  actionButtons.value = Data?.ActionButtons || [];
};

//上传附件
const handleUpload = (file: File, index?: number) => {
  if (!file) {
    if (visibleCompleted.value) {
      form6.value.PageFiles[index as number] = [];
      return;
    }
    if (currentStep.value == 1) {
      form5.value.PageFiles[index as number] = {};
    } else if (currentStep.value == 2) {
      form2.value.PageFiles[index as number] = {};
    } else if (currentStep.value == 3) {
      form4.value.PageFiles[index as number] = {};
    }
  } else {
    if (visibleCompleted.value) {
      let _file = Object.assign({}, file, { FileUrl: file.Url });
      form6.value.PageFiles[index as number] = _file;
      return;
    }
    if (currentStep.value == 1) {
      form5.value.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    } else if (currentStep.value == 2) {
      form2.value.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    } else if (currentStep.value == 3) {
      form4.value.PageFiles[index as number] = {
        ...file,
        FileUrl: file.Url,
      };
    }
  }
};

const handleTabChange = async (index: number) => {
  reEdit.value = false;
  if (flag.value) return;
  flag.value = true;
  if (index == 0) {
    BranchCompanyFlowId.value = filterCompanyCode("601");
    await BankAccountApply();
  } else if (index == 1) {
    BranchCompanyFlowId.value = filterCompanyCode("604");
    await getAccountTaxApplyInfo();
  } else if (index == 2) {
    if (activeKey.value == "605") {
      BranchCompanyFlowId.value = filterCompanyCode("605");
      await getTaxCategoryApplyInfo();
    } else {
      BranchCompanyFlowId.value = filterCompanyCode("602");
      await taxReporting();
    }
  } else if (index == 3) {
    BranchCompanyFlowId.value = filterCompanyCode("603");
    await bankAccountRegistration();
  }
  flag.value = false;
  if (document.querySelector("#app")) {
    document.querySelector("#app").scrollTop = 1;
  }
};

const filterCompanyCode = (code: string) => {
  WorkFlowId.value = -1;
  const { type, id } = route.query;
  const item_data = props.flowData.find((item) => item.Code == code);
  if (!item_data) {
    preData.value = {
      Title: "开业申请",
      PreConditionCode: "0",
      BranchCompanyFlowId: 0,
    };
  } else {
    currentData.value = props.flowData.find(
      (item: NodeItem) => item.Code == code
    );
    preData.value = props.flowData.find(
      (_item: NodeItem) => _item.Code == item_data?.PreConditionCode
    );
    if (currentData.value?.IsOperation) {
      //前置节点已完成
      preData.value = null;
    }
  }
  if (!type) {
    return item_data?.BranchCompanyFlowId || 0;
  } else if (code == type) {
    return id || item_data?.BranchCompanyFlowId || 0;
  } else if (code != type) {
    return item_data?.BranchCompanyFlowId || 0;
  }
};
const handleCallback = (update: boolean) => {
  if (visible.value) {
    visible.value = false;
  } else {
    visible.value = true;
  }
  if (update) {
    $emit("update-flow");
  }
};
const handleRejectback = () => {
  rejectedVisible.value = false;
  if (refresh.value) {
    refresh.value = false;
  } else {
    refresh.value = true;
  }
  $emit("update-flow");
  getList();
};
const handleApplyOnOk = () => {
  applyOnOkVisible.value = !applyOnOkVisible.value;
  refresh.value = !refresh.value;
  $emit("update-flow");
  getList();
};
const handleActiveTabChange = () => {
  reEdit.value = false;
  BranchCompanyFlowId.value = filterCompanyCode(activeKey.value);
  if (activeKey.value == "605") {
    getTaxCategoryApplyInfo();
  } else {
    taxReporting();
  }
};
const visibleCompleted = ref<boolean>(false);

const formRef5 = ref<FormInstance>();
const formRef6 = ref<FormInstance>();

let form5 = ref({
  PageFiles: [],
  PostFiles: [],
});
let form6 = ref({
  PageFiles: [],
});
const handleCancelComplete = () => {
  visibleCompleted.value = false;
  form6.value.PageFiles = [];
};
const submitComplete = () => {
  formRef6.value?.validateFields().then(async (res) => {
    //提交申请
    const { Success, Message } = await submitAccountTaxApply({
      BranchCompanyFlowId: 0, //提交补充资料相当于每次都是新申请
      PageFiles: [...form6.value.PageFiles, ...form5.value.PageFiles],
      IsSupplement: true,
    });
    if (Success) {
      message.success("已提交审核");
      $emit("update-flow");
      handleCancelComplete();
    } else {
      message.error(Message || "提交失败，请稍后重试");
    }
  });
};
const checkBoxChange = (e) => {
  if (!e.includes(9)) {
    taxForm.value.Description = "";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_RecallBack = _resolveComponent("RecallBack")!
  const _component_Reject = _resolveComponent("Reject")!
  const _component_ApplyOnOK = _resolveComponent("ApplyOnOK")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(HeadTitle, { title: "银行开户及税务报道流程" }),
        _createVNode(HelpText, {
          class: "border-bottom",
          list: list,
          width: 180,
          height: 70
        }),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(HeadTitle, { title: "银行开户及税务报道注意事项" }),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fileList, (item, index) => {
              return _createVNode(HelpFile, {
                key: index,
                title: item.title,
                "file-path": item.link,
                "file-type": item.type
              }, null, 8, ["title", "file-path", "file-type"])
            }), 64))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(HeadTitle, { title: "流程对接部门及名单" })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: require('@/assets/imgs/Book/attention.png')
          }, null, 8, _hoisted_7),
          _hoisted_8
        ]),
        _createVNode(_component_a_table, {
          pagination: false,
          dataSource: tableData,
          columns: _unref(USERLIST)
        }, null, 8, ["columns"])
      ]),
      (
        (_unref(personInfo).IsCreate == 1 || (id.value && _unref(personInfo).IsCreate == 0)) &&
        currentData.value &&
        currentData.value.IsDataAccess == 1
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(HeadTitle, { title: "审批事项" }),
              _createVNode(_component_a_steps, {
                class: "bussiness-step bank-steps",
                current: currentStep.value,
                "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((currentStep).value = $event)),
                size: "small",
                onChange: handleTabChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_step, {
                    title: "银行开户申请",
                    status: currentStep.value == 0 ? 'process' : 'wait'
                  }, null, 8, ["status"]),
                  _createVNode(_component_a_step, {
                    title: "开户报税资料申请",
                    status: currentStep.value == 1 ? 'process' : 'wait'
                  }, null, 8, ["status"]),
                  _createVNode(_component_a_step, {
                    title: "税务报道",
                    status: currentStep.value == 2 ? 'process' : 'wait'
                  }, null, 8, ["status"]),
                  _createVNode(_component_a_step, {
                    title: "银行开户备案",
                    status: currentStep.value == 3 ? 'process' : 'wait'
                  }, null, 8, ["status"])
                ]),
                _: 1
              }, 8, ["current"]),
              _createElementVNode("div", _hoisted_11, [
                (currentStep.value == 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (
                (id.value && _unref(personInfo).IsCreate == 0 && !form.value.YhBankName) ||
                WorkFlowId.value == 0 ||
                reEdit.value
              )
                        ? (_openBlock(), _createBlock(_component_a_form, {
                            key: 0,
                            class: "bank-form-wrapper",
                            validateTrigger: "blur",
                            model: form.value,
                            ref_key: "formRef1",
                            ref: formRef1,
                            labelAlign: "left",
                            "label-col": { style: { width: '100px' } }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _createVNode(_component_a_form_item, {
                                label: "开户行名称",
                                required: "",
                                colon: false,
                                style: {"width":"400px"},
                                name: "YhBankName",
                                rules: [
                  {
                    max: 50,
                  },
                ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    value: form.value.YhBankName,
                                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.YhBankName) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select_option, { value: "招商银行" }, {
                                        default: _withCtx(() => [
                                          _hoisted_13
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: "建设银行" }, {
                                        default: _withCtx(() => [
                                          _hoisted_14
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: "民生银行" }, {
                                        default: _withCtx(() => [
                                          _hoisted_15
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_select_option, { value: "广发银行" }, {
                                        default: _withCtx(() => [
                                          _hoisted_16
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _hoisted_17,
                              _createVNode(_component_a_form_item, {
                                label: "公司主体名称",
                                required: 
                  !!(
                    form.value.YhDocumentCollection.length > 0 &&
                    form.value.YhDocumentCollection[0]
                  )
                    ? true
                    : false
                ,
                                colon: false,
                                style: {"width":"400px"},
                                name: "YhCompanyEntity",
                                rules: [
                  {
                    max: 50,
                  },
                ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: form.value.YhCompanyEntity,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.YhCompanyEntity) = $event)),
                                    placeholder: "请填写营业执照名称"
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }, 8, ["required"]),
                              _createVNode(_component_a_checkbox_group, {
                                value: form.value.YhDocumentCollection,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.YhDocumentCollection) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, {
                                    wrap: true,
                                    style: {"margin-bottom":"8px"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(plainOptions, (item, index) => {
                                        return _createVNode(_component_a_col, {
                                          span: 4,
                                          key: index,
                                          style: {"margin-bottom":"16px"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_checkbox, {
                                              value: (index + 1).toString(),
                                              label: item
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["value", "label"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      }), 64))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          }, 8, ["model"]))
                        : (_openBlock(), _createBlock(Acccount, {
                            key: 1,
                            "flow-id": BranchCompanyFlowId.value,
                            detail: { PageData: form.value }
                          }, null, 8, ["flow-id", "detail"]))
                    ], 64))
                  : _createCommentVNode("", true),
                (currentStep.value == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_a_form, {
                        style: {"display":"flex"},
                        layout: "vertical",
                        validateTrigger: "blur",
                        model: _unref(form5),
                        ref_key: "formRef5",
                        ref: formRef5
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            name: ['PageFiles', 0, 'FileUrl'],
                            label: "资料提供申请表",
                            required: "",
                            style: {"margin-right":"30px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                      _unref(form5).PageFiles && _unref(form5).PageFiles.length > 0
                        ? _unref(form5).PageFiles[0].FileUrl
                        : ''
                    ,
                                "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                disable: !!preData.value,
                                onUpload: _cache[4] || (_cache[4] = (file) => handleUpload(file, 0)),
                                "download-link": {
                      filename: '资料提供申请表.docx',
                      fileKey: '5021',
                    },
                                "file-type": '521'
                              }, null, 8, ["value", "disable-close", "disable", "download-link"])
                            ]),
                            _: 1
                          }),
                          (_unref(form5).PostFiles.length > 0 && _unref(form5).PostFiles[0])
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 0,
                                style: {"margin-right":"60px"},
                                name: "PostFiles",
                                label: "资料提供申请表补充",
                                required: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(Image, {
                                    value: 
                      _unref(form5).PostFiles && _unref(form5).PostFiles.length > 0
                        ? _unref(form5).PostFiles[0].FileUrl
                        : ''
                    ,
                                    "disable-close": true,
                                    disable: true,
                                    "file-type": '5211'
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_a_form_item, {
                            name: ['PageFiles', 1, 'FileUrl'],
                            label: "用印、用证审批表",
                            required: "",
                            style: {"margin-right":"30px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(Image, {
                                value: 
                      _unref(form5).PageFiles && _unref(form5).PageFiles.length > 1
                        ? _unref(form5).PageFiles[1].FileUrl
                        : ''
                    ,
                                "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                disable: !!preData.value,
                                onUpload: _cache[5] || (_cache[5] = (file) => handleUpload(file, 1)),
                                "download-link": {
                      filename: '用印、用证审批表.docx',
                      fileKey: '5022',
                    },
                                "file-type": '522'
                              }, null, 8, ["value", "disable-close", "disable", "download-link"])
                            ]),
                            _: 1
                          }),
                          (_unref(form5).PostFiles.length > 1 && _unref(form5).PostFiles[1])
                            ? (_openBlock(), _createBlock(_component_a_form_item, {
                                key: 1,
                                name: ['PostFiles', 1, 'FileUrl'],
                                label: "用印、用证审批表补充",
                                required: "",
                                rules: [
                    { required: true, message: '请上传用印、用证审批表' },
                  ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(Image, {
                                    value: 
                      _unref(form5).PostFiles && _unref(form5).PostFiles.length > 1
                        ? _unref(form5).PostFiles[1].FileUrl
                        : ''
                    ,
                                    "disable-close": true,
                                    disable: true,
                                    "file-type": '5221'
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]))
                  : _createCommentVNode("", true),
                (currentStep.value == 2)
                  ? (_openBlock(), _createBlock(_component_a_tabs, {
                      key: 2,
                      activeKey: activeKey.value,
                      "onUpdate:activeKey": _cache[11] || (_cache[11] = ($event: any) => ((activeKey).value = $event)),
                      onChange: handleActiveTabChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tab_pane, {
                          key: "605",
                          tab: "税种申请"
                        }, {
                          default: _withCtx(() => [
                            (WorkFlowId.value == 0 || reEdit.value)
                              ? (_openBlock(), _createBlock(_component_a_checkbox_group, {
                                  key: 0,
                                  value: taxForm.value.TaxCategoryList,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((taxForm.value.TaxCategoryList) = $event)),
                                  onChange: checkBoxChange
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_row, {
                                      wrap: true,
                                      style: {"margin-bottom":"8px"}
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(taxOptions, (item, index) => {
                                          return _createVNode(_component_a_col, {
                                            span: index == 9 ? 18 : 6,
                                            key: index,
                                            style: {"margin-bottom":"16px","display":"flex"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_checkbox, {
                                                value: index,
                                                label: item
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(item), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["value", "label"]),
                                              (taxForm.value.TaxCategoryList.includes(9) && index == 9)
                                                ? (_openBlock(), _createBlock(_component_a_textarea, {
                                                    key: 0,
                                                    maxlength: 200,
                                                    style: {"width":"350px","margin-top":"-4px"},
                                                    value: taxForm.value.Description,
                                                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((taxForm.value.Description) = $event)),
                                                    placeholder: "请填写需要申请的税种",
                                                    "auto-size": ""
                                                  }, null, 8, ["value"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1032, ["span"])
                                        }), 64))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"]))
                              : (_openBlock(), _createBlock(_component_a_checkbox_group, {
                                  key: 1,
                                  disabled: "",
                                  value: taxDetailForm.value.TaxCategoryList,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((taxDetailForm.value.TaxCategoryList) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxDetailForm.value.TaxCategoryList, (item, index) => {
                                      return (_openBlock(), _createBlock(_component_a_checkbox, {
                                        key: index,
                                        class: _normalizeClass(index == 8 ? 'nomargin' : ''),
                                        value: item
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_19, [
                                            _createTextVNode(_toDisplayString(taxOptions[item.Type]), 1),
                                            (item.Type == 9)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString("(" + item.Description + ")"), 1))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["class", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"]))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_tab_pane, {
                          key: "602",
                          tab: "税务报道"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (WorkFlowId.value == 0 || reEdit.value)
                                ? (_openBlock(), _createBlock(_component_a_form, {
                                    key: 0,
                                    class: "bank-upload-form-wrapper",
                                    layout: "vertical",
                                    validateTrigger: "blur",
                                    model: _unref(form2),
                                    ref_key: "formRef2",
                                    ref: formRef2
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        name: ['PageFiles', 0, 'FileUrl'],
                                        label: "税务受理结果反馈单",
                                        required: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Image, {
                                            value: 
                          _unref(form2).PageFiles && _unref(form2).PageFiles.length > 0
                            ? _unref(form2).PageFiles[0].FileUrl
                            : ''
                        ,
                                            "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                            disable: !!preData.value,
                                            onUpload: _cache[9] || (_cache[9] = (file) => handleUpload(file, 0)),
                                            "download-link": {
                          filename: '税务受理结果反馈单.png',
                          fileKey: '6021',
                        },
                                            "file-type": '621'
                                          }, null, 8, ["value", "disable-close", "disable", "download-link"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_form_item, {
                                        name: ['PageFiles', 1, 'FileUrl'],
                                        label: "申请税控设备回执单",
                                        required: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(Image, {
                                            value: 
                          _unref(form2).PageFiles && _unref(form2).PageFiles.length > 1
                            ? _unref(form2).PageFiles[1].FileUrl
                            : ''
                        ,
                                            "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                            disable: !!preData.value,
                                            onUpload: _cache[10] || (_cache[10] = (file) => handleUpload(file, 1)),
                                            "download-link": {
                          filename: '申请税控设备回执单.png',
                          fileKey: '6022',
                        },
                                            "file-type": '622'
                                          }, null, 8, ["value", "disable-close", "disable", "download-link"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["model"]))
                                : (_openBlock(), _createBlock(Tax, {
                                    key: 1,
                                    style: {"border-bottom":"1px solid #eee"},
                                    "flow-id": BranchCompanyFlowId.value,
                                    detail: {
                      PageFiles: _unref(form2).PageFiles,
                    }
                                  }, null, 8, ["flow-id", "detail"]))
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["activeKey"]))
                  : _createCommentVNode("", true),
                (currentStep.value == 3)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      (
                (id.value && _unref(personInfo).IsCreate == 0 && !_unref(form3).AccountName) ||
                WorkFlowId.value == 0 ||
                reEdit.value
              )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_a_form, {
                              class: "bank-registration-form-wrapper",
                              layout: "inline",
                              "label-col": { style: { width: '130px' } },
                              labelAlign: "left",
                              ref_key: "formRef3",
                              ref: formRef3,
                              model: _unref(form3)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "账户名称",
                                  class: "register-form-item",
                                  name: ['AccountName'],
                                  required: "",
                                  colon: false,
                                  rules: [
                    {
                      max: 50,
                    },
                  ]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _unref(form3).AccountName,
                                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form3).AccountName) = $event)),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  label: "开户行名称",
                                  class: "register-form-item",
                                  name: ['BankName'],
                                  required: "",
                                  colon: false,
                                  rules: [
                    {
                      max: 50,
                    },
                  ]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _unref(form3).BankName,
                                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form3).BankName) = $event)),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  label: "账号",
                                  class: "register-form-item",
                                  name: ['AccountNumber'],
                                  style: {"margin-bottom":"20px"},
                                  required: "",
                                  colon: false,
                                  rules: [
                    {
                      max: 50,
                    },
                  ]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _unref(form3).AccountNumber,
                                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form3).AccountNumber) = $event)),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  class: "register-form-item register-form-item-special",
                                  name: ['DepositAccountNumber'],
                                  style: {"margin-bottom":"20px"},
                                  colon: false,
                                  required: "",
                                  rules: [
                    { required: true, message: '请输入基本存款账户编号' },
                    {
                      max: 50,
                      message: '基本存款账户编号最多不超过50字',
                    },
                  ]
                                }, {
                                  label: _withCtx(() => [
                                    _hoisted_21
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _unref(form3).DepositAccountNumber,
                                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form3).DepositAccountNumber) = $event)),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  label: "开户日期",
                                  class: "register-form-item",
                                  name: ['OpeningDate'],
                                  required: "",
                                  colon: false,
                                  rules: [
                    {
                      max: 50,
                    },
                  ]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_date_picker, {
                                      locale: _unref(locale),
                                      value: _unref(form3).OpeningDate,
                                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form3).OpeningDate) = $event)),
                                      style: {"width":"300px"},
                                      valueFormat: "YYYY-MM-DD",
                                      placeholder: "请选择",
                                      showToday: true
                                    }, null, 8, ["locale", "value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  label: "客户经理姓名",
                                  class: "register-form-item",
                                  name: ['AccountManagerName'],
                                  disabled: "",
                                  colon: false,
                                  rules: [
                    {
                      max: 50,
                    },
                  ]
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _unref(form3).AccountManagerName,
                                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(form3).AccountManagerName) = $event)),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  class: "register-form-item register-form-item-special",
                                  name: ['AccountManagerPhone'],
                                  rules: [
                    {
                      required: true,
                      message: '请输入客户经理电话/柜台电话',
                    },
                    {
                      max: 50,
                      message: '客户经理电话/柜台电话最多不超过50字',
                    },
                  ],
                                  colon: false
                                }, {
                                  label: _withCtx(() => [
                                    _hoisted_22
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input, {
                                      value: _unref(form3).AccountManagerPhone,
                                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(form3).AccountManagerPhone) = $event)),
                                      placeholder: "请输入"
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["model"]),
                            _createVNode(_component_a_form, _mergeProps({
                              layout: "vertical",
                              model: _unref(form4)
                            }, formItemLayout, {
                              ref_key: "formRef4",
                              ref: formRef4,
                              class: "form-upload"
                            }), {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "开户许可证",
                                  class: "form-upload-item",
                                  name: ['PageFiles', 0, 'FileUrl'],
                                  required: "",
                                  style: {"width":"170px","margin-right":"34px"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(Image, {
                                      value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 0
                        ? _unref(form4).PageFiles[0].FileUrl
                        : ''
                    ,
                                      "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                      disable: !!preData.value,
                                      "file-type": '631',
                                      onUpload: _cache[19] || (_cache[19] = (file) => handleUpload(file, 0))
                                    }, null, 8, ["value", "disable-close", "disable"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  name: ['PageFiles', 1, 'FileUrl'],
                                  label: "银行预留印鉴卡",
                                  class: "form-upload-item",
                                  style: {"width":"170px","margin-right":"34px"},
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(Image, {
                                      value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 1
                        ? _unref(form4).PageFiles[1].FileUrl
                        : ''
                    ,
                                      "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                      disable: !!preData.value,
                                      "file-type": '632',
                                      onUpload: _cache[20] || (_cache[20] = (file) => handleUpload(file, 1))
                                    }, null, 8, ["value", "disable-close", "disable"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_form_item, {
                                  name: ['PageFiles', 2, 'FileUrl'],
                                  label: "开户回执资料(全套)",
                                  class: "form-upload-item",
                                  style: {"width":"170px","margin-right":"34px"},
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(Image, {
                                      "disable-close": WorkFlowId.value != 0 && !reEdit.value,
                                      disable: !!preData.value,
                                      "file-type": '633',
                                      value: 
                      _unref(form4).PageFiles && _unref(form4).PageFiles.length > 2
                        ? _unref(form4).PageFiles[2].FileUrl
                        : ''
                    ,
                                      onUpload: _cache[21] || (_cache[21] = (file) => handleUpload(file, 2))
                                    }, null, 8, ["disable-close", "disable", "value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 16, ["model"])
                          ], 64))
                        : (_openBlock(), _createBlock(Register, {
                            key: 1,
                            detail: { ..._unref(form3), ..._unref(form4) },
                            "folw-id": BranchCompanyFlowId.value
                          }, null, 8, ["detail", "folw-id"]))
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_RecallBack, {
                  id: BranchCompanyFlowId.value,
                  show: visible.value,
                  onClose: handleCallback
                }, null, 8, ["id", "show"]),
                (currentData.value && currentData.value.State > 1 && !reEdit.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(HeadTitle, {
                        title: '审批流程',
                        class: "flow-box-headtitle"
                      }),
                      _createVNode(Approval, {
                        id: WorkFlowId.value,
                        refresh: refresh.value
                      }, null, 8, ["id", "refresh"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (actionButtons.value.length > 0)
      ? (_openBlock(), _createBlock(ButtonGroup, {
          key: 0,
          "type-list": actionButtons.value,
          onClick: handleClick,
          "show-tips": 
      preData.value && preData.value.Title
        ? `提示：完成${preData.value.Title}审批后方可申请该模块`
        : ''
    
        }, null, 8, ["type-list", "show-tips"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Reject, {
      id: WorkFlowId.value,
      show: rejectedVisible.value,
      onClose: handleRejectback
    }, null, 8, ["id", "show"]),
    _createVNode(_component_ApplyOnOK, {
      id: WorkFlowId.value,
      show: applyOnOkVisible.value,
      onClose: handleApplyOnOk
    }, null, 8, ["id", "show"]),
    _createVNode(_component_a_modal, {
      class: "modal-dialog",
      bodyStyle: {
      width: '460px',
      height: '216px',
    },
      visible: visibleCompleted.value,
      "onUpdate:visible": _cache[24] || (_cache[24] = ($event: any) => ((visibleCompleted).value = $event)),
      title: "开户报税资料补充申请",
      onOk: submitComplete,
      onCancel: handleCancelComplete
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          style: {"display":"flex"},
          layout: "vertical",
          model: _unref(form6),
          ref_key: "formRef6",
          ref: formRef6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              style: {"margin-right":"60px"},
              name: ['PageFiles', 0, 'FileUrl'],
              label: "资料提供申请表",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: 
            _unref(form6).PageFiles && _unref(form6).PageFiles.length > 0
              ? _unref(form6).PageFiles[0].FileUrl
              : ''
          ,
                  "disable-close": false,
                  disable: false,
                  onUpload: _cache[22] || (_cache[22] = (file) => handleUpload(file, 0)),
                  "file-type": 5211
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: ['PageFiles', 1, 'FileUrl'],
              label: "用印、用证审批表",
              required: "",
              rules: [{ required: true, message: '请上传用印、用证审批表' }]
            }, {
              default: _withCtx(() => [
                _createVNode(Image, {
                  value: 
            _unref(form6).PageFiles && _unref(form6).PageFiles.length > 1
              ? _unref(form6).PageFiles[1].FileUrl
              : ''
          ,
                  "disable-close": false,
                  disable: false,
                  onUpload: _cache[23] || (_cache[23] = (file) => handleUpload(file, 1)),
                  "file-type": 5221
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})